module.exports = __webpack_public_path__ + "static/media/default-avatar.1eb7fff2.jpg";